import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const IngredientScalingFactorCard = ({
	state,
	handlers,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();
	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);
	return (
		<FoldableCard
			unlockable={isIngredientEditor}
			dataComponentType="ingredient-scaling-factor-card"
			defaultOpen={true}
			title={t('ingredient:SCALING_FACTOR')}
			hasLock={true}
			defaultLocked={state.locked.scalingFactor}
			handleLockClick={(input: boolean) =>
				input ? handlers.lock('scalingFactor') : handlers.unlock('scalingFactor')
			}
			content={
				<div className="card-body">
					<label>{t('ingredient:NON_LINEAR_SCALING_FACTOR')}</label>
					<RoundedInput
						disabled={!isIngredientEditor}
						error-key="ScalingFactor"
						handleChange={handlers.setScalingFactor}
						name="scalingFactor"
						value={state.scalingFactor ?? state.baseIngredientScalingFactor ?? 1}
					/>
				</div>
			}
		/>
	);
};
